<template>
  <div
    class="table-search-container"
  >
    时间：
    <a-date-picker
      @change="value=>$emit('onStartTime',value)"
    />
    <a-date-picker
      class="select-container"
      @change="value=>$emit('onEndTime',value)"
    />
    <a-input-search
      class="select-container"
      placeholder="请输入用户"
      style="width:150px;"
      @search="value => $emit('onSearchUser', value)"
    />
    <a-input-search
      class="select-container"
      placeholder="请输入搜索内容"
      style="width:200px;"
      @search="value => $emit('onSearch', value)"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    filterOption(input, option) {
      // return (
      //   option.componentOptions.children[0].text
      //     .toLowerCase()
      //     .indexOf(input.toLowerCase()) >= 0
      // );
    },
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
  .select-container{
    margin-right:10px;
  }
}
</style>
